var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,_vm._g(_vm._b({tag:"component",class:{
    'cursor-pointer': _vm.isLink,
  },attrs:{"to":_vm.isLink && _vm.isNuxtLink ? _vm.path : undefined,"href":_vm.path || undefined}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }